import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import productBrandVariantStyles from "@sc/App/SharedStyles/ProductBrandStyles";
import productDescriptionVariantStyles from "@sc/App/SharedStyles/ProductDescriptionStyles";

pageTitleStyles.titleText = {
    variant: "h1",
    ...productDescriptionVariantStyles.large?.productDetailDescription,
};

pageTitleStyles.brandStyles = {
   ...productBrandVariantStyles.medium,
};
